<div class='navigationPlaceholder'>
</div>
<div class='navigationWrapper' [style.margin-bottom.px]="marginBottom ?? 0">
  <div class='navigation'>
    <button pButton id="prevButton" type="button" icon="pi pi-step-backward" (click)="buttonPreviousClicked()"
      *ngIf="PrevButtonVisible"></button>
    <div style="margin-left: 10px; margin-right: 10px; flex-grow: 1;">
      <p-progressbar id="progress" [value]="progess"></p-progressbar>
    </div>
    <button pButton id="nextButton" type="button" icon="pi pi-step-forward" (click)="buttonNextClicked()"
      *ngIf="NextButtonVisible">
    </button>
  </div>
</div>
